/**
 * Emoji size = multiplier on the surrounding text (1 = same as text).
 * Edit these values — they drive CSS variables on the root `.App` element.
 */
export const emojiSizes = {
  /** 😉 😌 in intro / hints (small body text) */
  inline: 1.85,
  /** Story screens (TEXT_SCREENS) — smaller than inline hints */
  line: 1.25,
  /** 👋 next to the main title */
  wave: 1,
};
